/**
 * Created by anthony on 7/8/14.
 */
var awardLetterModel = angular.module('awardLetterModel', ['appModel']);
awardLetterModel.factory('AwardLetterModelFactory', function(ApplicationService, RestService, authServiceFactory, AppModelFactory){
    var AwardLetterModel = function(){
        this.endpoint = '/AwardLetter';
        this.primaryKey = "recordID";
    }
    AwardLetterModel.prototype = new AppModelFactory();
    AwardLetterModel.prototype.parent = AppModelFactory.prototype;
    AwardLetterModel.prototype.resolveData = function(schoolID)
    {
        var parent = this;
        return this.parent.resolveData.apply(this, arguments).then(function(data)
        {
            parent.data = data[0].data;
        });

    }
    AwardLetterModel.prototype.new = function()
    {
        var dt = new Date();
        var appeal = {schoolID: authServiceFactory.getAuth().schoolID, title: '', text: '', date: dt.getDateMySqlFormatted()};
        return (ApplicationService.getAwardData()['awardLetters'].push(appeal)) - 1;

    }
    return AwardLetterModel;
});


awardLetterModel.service('AwardLetterModelService', function(AwardLetterModelFactory){
    var awardLetterModel = new AwardLetterModelFactory();
    return awardLetterModel;
});


